import type { ElementType, ReactNode } from "react";

import { css } from "@compiled/react";
// @ts-ignore types aren't installed
import sanitizeHtml from "sanitize-html";

import { colors } from "@/components/product-demos/animated-jira-tour/src/helpers/colors";
import { wacToken } from "@/libraries/design/foundations";

const styles = css({
    "&.styled-text": {
        fontSize: "1rem",
        lineHeight: "1.5rem",
        fontWeight: 400,
        color: colors.text,
        fontFamily: wacToken("font.charlie.text"),
        margin: 0,

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        a: {
            "color": "#0052cc",
            "textDecoration": "none",

            ":hover": {
                // eslint-disable-next-line local/ensure-wac-token-usage
                color: "#0065ff",
                textDecoration: "underline"
            },
            ":active": {
                textDecoration: "none"
            },
            ":focus": {
                textDecoration: "none"
            },
            ":visited": {
                // eslint-disable-next-line local/ensure-wac-token-usage
                color: "#0052cc"
            }
        },

        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        p: {
            "margin": 0,
            ":not(:last-child)": {
                marginBlockEnd: 24
            }
        }
    }
});

export type SanitizedHtmlProps = {
    // @ts-expect-error - TS2304: Cannot find name 'InnerHTML'
    readonly innerHTML: string | InnerHTML | ReactNode[];
    readonly tagName?: ElementType;
    readonly className?: string;
};

export const SanitizedRichText = ({
    innerHTML,
    tagName: Component = "span",
    className
}: SanitizedHtmlProps) => {
    if (typeof innerHTML === "string") {
        return (
            <Component
                css={styles}
                className={`styled-text ${className ?? ""}`}
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(innerHTML) }}
            />
        );
    } else {
        return null;
    }
};
